export default class PaymentsApi {
  constructor(client) {
    this.client = client;
  }

  async createSetupIntent(userId) {
    return this.client.request(`/api/payments/create-setup-intent`, {
      method: 'POST',
      body: JSON.stringify({ customerId: userId || null }),
      headers: { 'Content-Type': 'application/json' },
    });
  }

  async addPaymentMethod(userId, paymentMethodId) {
    return this.client.request(`/api/payments/add-payment-method`, {
      method: 'POST',
      body: JSON.stringify({ userId, paymentMethodId }),
      headers: { 'Content-Type': 'application/json' },
    });
  }

  async getPaymentMethods(userId) {
    return this.client.request(`/api/payments/payment-methods?userId=${userId}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });
  }

  async createPaymentIntent({ caseId, customerId, paymentMethodId, amount }) {
    return this.client.request(`/api/payments/charge`, {
      method: 'POST',
      body: JSON.stringify({ caseId, customerId, paymentMethodId, amount }),
      headers: { 'Content-Type': 'application/json' },
    });
  }

  async deletePaymentMethod(paymentMethodId, userId) {
    // Use DELETE and include userId as query param for server-side verification
    const url = `/api/payments/payment-methods/${encodeURIComponent(paymentMethodId)}?userId=${encodeURIComponent(
      userId || ''
    )}`;
    return this.client.request(url, { method: 'DELETE' });
  }
}
